<template>
    <div class="page-about-awards">
        <div class="year-filter-select">
            <div class="drop-filter-name" :class="{'open' : open_filter}">
                <a href="#" @click.prevent="open_filter = !open_filter">{{ activeYear }}</a>
                <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
            </div>
            <div class="dropdown-menu" :class="{'open' : open_filter}">
                <simplebar data-simplebar-auto-hide="false" class="dropdown-scroll-container">
                    <div class="drop-checkbox-container">
                        <div class="item-R" :class="{'active' : activeYear == 'Все года', 'active' : activeYear == 'Барлық жылдар'}" @click="filterAwardsItems('all')">
                            <span v-if="globalLang != 'kz/'">Все года</span>
                            <span v-else>Барлық жылдар</span>
                        </div>
                        <div class="item-R" v-for="item in yearList" :class="{'active' : activeYear == item}" @click="filterAwardsItems(item)">
                            <span>{{ item }}</span>
                        </div>
                    </div>
                </simplebar>
            </div>
        </div>
        <div class="awards-cards">
            <div class="card-item" v-for="item in awardsCards">
                <div class="card-award-img"><img :src="item.award_img" alt=""></div>
                <div class="card-info">
                    <strong>{{ item.name }}</strong>
                    <span>{{ item.complex.name }}</span>
                    <p v-html="item.desc"></p>
                </div>
                <div class="card-img">
                    <img :src="item.img" alt="" v-if="!isMobileChecker">
                    <img :src="item.img_mobile" alt="" v-else>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import simplebar from 'simplebar-vue';
    import 'simplebar-vue/dist/simplebar.min.css';
    export default {
        name: 'about-page-awards',
        components: {
            svgIcon,
            simplebar,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Награды',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                open_filter: false,
                awardsCards: null,
                yearList: null,
                activeYear: 'Все года',
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            filterAwardsItems(param) {
                this.open_filter = false;
                var arr = this.aboutPage.awards_card;
                // console.log(param)
                this.awardsCards = [];
                if (param == 'all') {
                    if (this.globalLang != 'kz/') {
                        this.activeYear = 'Все года';
                    } else {
                        this.activeYear = 'Барлық жылдар';
                    }
                    this.awardsCards = this.aboutPage.awards_card;
                } else {
                    this.activeYear = param;
                    var filterItems = arr.filter(function( obj ) {
                        return obj.year == param;
                    }); 
                    this.awardsCards = filterItems;
                }
            },
            buildYearsFilter() {
                var arr = this.aboutPage.awards_card;
                var years = [];
                for (var i=0; i < arr.length; i++) {
                    years.push(arr[i].year);
                }
                this.yearList = this.uniqueElementsInArray(years).sort().reverse();
            },
            uniqueElementsInArray(arr) {
                let result = [];
                for (let str of arr) {
                    // console.log(str, 'unique')
                    if (!result.includes(str)) {
                        result.push(str);
                    }
                }
                return result;
            },
        },
        beforeCreate() {
            document.body.dataset.page = 'about-awards';
        },
        created () {
        },
        mounted() {
            this.filterAwardsItems('all');
            this.buildYearsFilter();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/awards-section.scss';
    @import '@/styles/components/about-page/respond/awards-section-respond.scss';
</style>